/* ============================================================
   MICTLÁN — Paneles <dialog> (menú de mx-header y filtros de
   mx-col-productos)
   ============================================================
   Abre y cierra cualquier <dialog data-mx-dialogo>. Los acordeones
   de adentro son <details> nativos, sin JS.
   · [data-mx-menu-abrir="<id del dialog>"]  abre
   · [data-mx-menu-cerrar]                    cierra (dentro del dialog)
   · Clic en el fondo oscuro o Esc también cierran.
   Delegado en document: sigue funcionando si el customizer recarga
   la sección.
   ============================================================ */
(function () {
  'use strict';
  if (window.__mxDialogos) return; // el script puede venir de varias secciones
  window.__mxDialogos = true;

  function botonesDe(dialog) {
    return document.querySelectorAll('[data-mx-menu-abrir="' + dialog.id + '"]');
  }

  function marcar(dialog, abierto) {
    botonesDe(dialog).forEach(function (b) {
      b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
    document.documentElement.style.overflow = abierto ? 'hidden' : '';
  }

  function abrir(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    marcar(dialog, true);
  }

  function cerrar(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    var abre = e.target.closest('[data-mx-menu-abrir]');
    if (abre) {
      abrir(document.getElementById(abre.getAttribute('data-mx-menu-abrir')));
      return;
    }

    var cierra = e.target.closest('[data-mx-menu-cerrar]');
    if (cierra) {
      cerrar(cierra.closest('dialog'));
      return;
    }

    // Clic en el ::backdrop: el target es el propio <dialog>.
    if (e.target.matches && e.target.matches('dialog[data-mx-dialogo]')) cerrar(e.target);
  });

  // `close` cubre Esc, el botón y el backdrop.
  document.addEventListener(
    'close',
    function (e) {
      if (e.target.matches && e.target.matches('dialog[data-mx-dialogo]')) marcar(e.target, false);
    },
    true
  );
})();
